"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _v = _interopRequireDefault(require("uuid/v1"));
var _ = require(".");
var _2 = _interopRequireWildcard(require(".."));
var Components = _2;
var _components = require("../../components");
var FormComponents = _interopRequireWildcard(require("../Forms"));
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _translationentries = require("../../modules/translationentries");
var _WebRequestHelper = require("../../helpers/WebRequestHelper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable react/jsx-no-undef */
const mapStateToProps = (state, props) => {
  if (!state[props.entity.plural]) {
    console.error(`There is no ${props.entity.plural} in state. Maybe you have forgotten to register the reducer.`);
  }
  return {
    [props.entity.plural]: state[props.entity.plural]
  };
};
const mapDispatchToProps = (dispatch, props) => {
  const {
    actions
  } = props;
  return {
    getAllTranslationEntries: (0, _redux.bindActionCreators)(actions.getAllTranslationEntries, dispatch),
    mergeSchema: (0, _redux.bindActionCreators)(actions.mergeSchema, dispatch)
  };
};
class TranslateElementsTable extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "getLanguages", () => {
      return (0, _WebRequestHelper.createRequest)(true).then(request => {
        request.method = "get";
        request.url = `languages`;
        return (0, _WebRequestHelper.sendRequest)(request).then(response => {
          this.setState({
            languages: response.data
          });
        }).catch(error => {
          console.dir(error);
          this.setState({
            fetching: false
          });
          this.throw(error.Message ? error.Message : `Oops, something went wrong.`);
        });
      }).catch(error => {
        console.dir(error);
        this.setState({
          fetching: false
        });
        this.throw(error.Message ? error.Message : `Oops, something went wrong.`);
      });
    });
    _defineProperty(this, "handleSelectLanguageFrom", val => {
      this.setState({
        languageFrom: val,
        fetching: true
      });
      this.props.actions.getAllTranslationEntries(val).then(translateEntries => {
        const translateEntriesFormatted = this.props.actions.mergeSchema(translateEntries, "LanguageFrom");
        this.setState({
          translationsArray: translateEntriesFormatted,
          fetching: false
        });
      }).catch(error => {
        console.dir(error);
        this.setState({
          fetching: false
        });
        this.throw(error.Message ? error.Message : `Oops, something went wrong.`);
      });
    });
    _defineProperty(this, "handleSelectLanguageTo", val => {
      this.setState({
        languageTo: val,
        fetching: true
      });
      _translationentries.config.translateElementsTable.schema.LanguageTo.editable = true;
      this.props.actions.getAllTranslationEntries(val).then(translateEntries => {
        const translateEntriesFormatted = this.props.actions.mergeSchema(translateEntries, "LanguageTo");
        for (let translationsEntry of this.state.translationsArray) {
          translationsEntry.LanguageTo = "";
          for (let languageToEntry of translateEntriesFormatted) {
            if (translationsEntry.TranslationId === languageToEntry.TranslationId) {
              translationsEntry.LanguageTo = languageToEntry.LanguageTo;
              translationsEntry["TranslatedElementId"] = languageToEntry.Id;
              break;
            }
          }
          this.setState({
            ...this.state,
            fetching: false
          });
        }
      }).catch(error => {
        console.dir(error);
        this.setState({
          fetching: false
        });
        this.throw(error.Message ? error.Message : `Oops, something went wrong.`);
      });
    });
    _defineProperty(this, "onChangeTranslation", (attr, value, row) => {
      this.setState(state => {
        const updatedTranslationsArray = state.translationsArray.map(item => {
          if (item.Id === row) {
            item[attr] = value;
            item.Dirty = true;
          }
        });
        return updatedTranslationsArray;
      });
    });
    _defineProperty(this, "onSubmitTranslation", () => {
      this.setState({
        errors: [],
        messages: []
      });
      for (let translationElement of this.state.translationsArray) {
        let dirty = translationElement.Dirty || false;
        if (dirty) {
          // This element was modified, so it will be created or updated.

          translationElement.Dirty = false; // Reset the element in case the "Save" button is clicked multiple times

          let body = {
            Id: translationElement.TranslatedElementId && translationElement.TranslatedElementId,
            // The element exists, copy Id
            LanguageId: this.state.languageTo.Id,
            TranslationId: translationElement.TranslationId,
            Value: translationElement.LanguageTo,
            Category: translationElement.Category,
            Comment: ""
          };
          (0, _WebRequestHelper.createRequest)(true).then(request => {
            request.method = body.Id ? "put" : "post"; // If the element already exists, update it. Othersiwe, create it.
            request.url = body.Id ? `translationentries/${body.Id}` : "translationentries";
            request.data = body;
            (0, _WebRequestHelper.sendRequest)(request).then(response => {
              // We update the state with the element ID so next time the element just gets updated.

              const newList = this.state.translationsArray.map(translationElement => {
                if (translationElement.TranslationId === response.data.TranslationId) {
                  const updatedElement = {
                    ...translationElement,
                    TranslatedElementId: response.data.Id
                  };
                  return updatedElement;
                }
                return translationElement;
              });
              this.setState({
                ...this.state,
                translationsArray: newList
              });
              this.setState({
                fetching: false
              });
              this.message(`Text translated successfully`);
            }).catch(error => {
              console.dir(error);
              this.setState({
                fetching: false
              });
              this.throw(error.Message ? error.Message : `Oops, something went wrong.`);
            });
          }).catch(error => {
            console.dir(error);
            this.setState({
              fetching: false
            });
            this.throw(error.Message ? error.Message : `Oops, something went wrong.`);
          });
        }
      }
      return false;
    });
    _defineProperty(this, "toggleModalDialog", () => {
      this.setState({
        modalDialogOpen: !this.state.modalDialogOpen
      });
    });
    _defineProperty(this, "handleDeleteSelected", () => {
      this.props.onDelete(this.props.selection);
      this.toggleModalDialog();
    });
    _defineProperty(this, "columnSort", selectedColumn => {
      const {
        [this.props.entity.plural]: entity
      } = this.props;
      let storeOrder = entity.list.order;
      const {
        onSort
      } = this.props;
      let sortBy = Array.from(storeOrder);
      let sortColumn = null;
      let sortOrder = null;
      let sortIndex = null;
      new Promise(resolve => {
        if (!storeOrder.length) {
          /* First column sorting */

          sortBy.push({
            column: selectedColumn,
            order: "ASC"
          });
          this.setState({
            sorted: true,
            previousSelectedColumn: selectedColumn,
            sortBy: sortBy
          });
          return resolve();
        } else {
          let isColumnSorted = false;
          for (let i in sortBy) {
            /* Check which column was clicked */

            if (sortBy[i].column === selectedColumn) {
              isColumnSorted = true;
              sortColumn = sortBy[i].column;
              sortOrder = sortBy[i].order;
              sortIndex = i;
            }
          }
          switch (sortOrder) {
            case null:
              if (isColumnSorted === false) {
                sortBy.push({
                  column: selectedColumn,
                  order: "ASC"
                });
              } else {
                for (var x in sortBy) {
                  if (sortBy[x].column === sortColumn) {
                    sortBy[x].order = "ASC";
                  }
                }
              }
              this.setState({
                sorted: true,
                previousSelectedColumn: selectedColumn,
                sortBy: sortBy
              });
              return resolve();
            case "ASC":
              for (var i in sortBy) {
                if (sortBy[i].column === sortColumn) {
                  sortBy[i].order = "DESC";
                }
              }
              this.setState({
                sorted: true,
                previousSelectedColumn: selectedColumn,
                sortBy: sortBy
              });
              return resolve();
            case "DESC":
              for (var j in sortBy) {
                if (sortBy[j].column === sortColumn) {
                  sortBy.splice(j, 1);
                }
              }
              this.setState({
                sorted: sortBy.length ? true : false,
                previousSelectedColumn: null,
                sortBy: sortBy
              });
              return resolve();
            default:
              for (var k in sortBy) {
                if (sortBy[k].column === sortColumn) {
                  sortBy.splice(k, 1);
                }
              }
              this.setState({
                sorted: sortBy.length ? true : false,
                previousSelectedColumn: null,
                sortBy: sortBy
              });
              return resolve();
          }
        }
      }).then(() => {
        onSort(sortBy);
      });
    });
    _defineProperty(this, "throw", message => {
      this.setState(prev => {
        return {
          errors: [{
            Id: (0, _v.default)(),
            Message: message
          }]
        };
      });
    });
    _defineProperty(this, "message", message => {
      this.setState(prev => {
        return {
          messages: [{
            Id: (0, _v.default)(),
            Message: message
          }]
        };
      });
    });
    this.state = {
      sorted: false,
      previousSelectedColumn: null,
      sortBy: [],
      modalDialogOpen: false,
      languageFrom: {},
      languageTo: {},
      translationsArray: this.props.values,
      errors: [],
      messages: [],
      fetching: false
    };
    this.getLanguages();
  }
  onRead(id) {
    this.setState(prev => {
      return {
        errors: prev.errors.filter(error => error.Id !== id),
        messages: prev.messages.filter(message => message.Id !== id)
      };
    });
  }
  render() {
    const {
      selection,
      values,
      onClick,
      onSelect,
      fetched,
      onSelectAll,
      onChange,
      [this.props.entity.plural]: entity,
      ...rest
    } = this.props;
    const {
      languages,
      languageFrom,
      languageTo,
      translationsArray,
      errors,
      messages,
      fetching
    } = this.state;
    const translateColumns = Object.values(_translationentries.config.translateElementsTable.schema);
    let storeOrder = entity.list.order;
    const allSelected = values ? selection.length === values.length : false;
    const uuid = (0, _v.default)();
    if (fetching) return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_2.Spinner, null));
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "mb-4"
    }, Object.entries(languageFrom).length !== 0 && Object.entries(languageTo).length !== 0 ? /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-primary",
      onClick: this.onSubmitTranslation
    }, "Save") : /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "btn btn-primary",
      disabled: true
    }, "Save")), !!errors.length && errors.map(error => /*#__PURE__*/_react.default.createElement("div", {
      key: error.Id,
      className: "alert alert-danger alert-dismissible fade show"
    }, error.Message.length < 200 ? error.Message : "Oops, something went wrong.", /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "close",
      "data-dismiss": "alert",
      "aria-label": "Close",
      onClick: () => this.onRead(error.Id)
    }, /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7")))), !!messages.length && messages.map(message => /*#__PURE__*/_react.default.createElement("div", {
      key: message.Id,
      className: "alert alert-success alert-dismissible fade show"
    }, message.Message, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "close",
      "data-dismiss": "alert",
      "aria-label": "Close",
      onClick: () => this.onRead(message.Id)
    }, /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7")))), selection.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex justify-content-between align-items-center",
      style: {
        height: "3rem"
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "text-left mt-1 mb-3"
    }, selection.length, " item", selection.length !== 1 && `s`, " selected"), /*#__PURE__*/_react.default.createElement("div", {
      className: "text-right"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "btn btn-lg btn-transparent mt-1 mb-3",
      onClick: this.toggleModalDialog
    }, /*#__PURE__*/_react.default.createElement(Icon, {
      icon: "delete",
      size: 20
    })))), /*#__PURE__*/_react.default.createElement("table", {
      className: "table table-hover"
    }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, languages && translateColumns.map((column, index) => /*#__PURE__*/_react.default.createElement(_.TranslateTableColumnHeader, {
      key: index,
      column: column,
      sortBy: storeOrder,
      onSort: () => this.columnSort(translateColumns[index].key),
      languages: languages,
      handleSelectLanguageFrom: this.handleSelectLanguageFrom,
      handleSelectLanguageTo: this.handleSelectLanguageTo,
      languageFrom: languageFrom,
      languageTo: languageTo,
      translationsArray: translationsArray
    })))), /*#__PURE__*/_react.default.createElement("tbody", null, fetched && translationsArray.map((row, index) => {
      const selected = selection.some(selected => selected === row.Id);
      return /*#__PURE__*/_react.default.createElement("tr", {
        key: `${row.Id || index}-row`,
        className: selected ? "table-active" : ""
      }, translateColumns.map((column, index) => {
        const value = column.type === "Join" ? row[column.entities.join] : row[column.key];
        const Component = column.component || (column.editable ? FormComponents[column.type] : Components[column.type] || (() => /*#__PURE__*/_react.default.createElement("div", null, value ? JSON.stringify(value) : "")));
        return /*#__PURE__*/_react.default.createElement("td", {
          key: `${row.Id || index}-col-${index}`,
          className: "position-relative"
        }, onClick && row.Id && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: onClick(row.Id),
          className: "table-link"
        }), /*#__PURE__*/_react.default.createElement("span", {
          className: "position-relative",
          style: {
            cursor: "pointer"
          }
        }, onClick && row.Id && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: onClick(row.Id),
          className: "table-link"
        }), /*#__PURE__*/_react.default.createElement(Component, _extends({}, rest, {
          row: row,
          value: value,
          format: column.format,
          fetched: fetched,
          fetching: fetching,
          schema: column,
          onChange: val => this.onChangeTranslation(column.key || column.id, val, row.Id),
          edit: column.editable
        }))));
      }));
    }))), Object.keys(languageFrom).length === 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: "mt-5 mb-5"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Please select the language from which you want to translate.")), Object.keys(languageFrom).length !== 0 && translationsArray.length === 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: "mt-5 mb-5"
    }, /*#__PURE__*/_react.default.createElement("p", null, "The language ", languageFrom.DisplayName, " has no entries, please select a different one.")), /*#__PURE__*/_react.default.createElement("div", {
      className: "mt-4"
    }, Object.entries(languageFrom).length !== 0 && Object.entries(languageTo).length !== 0 ? /*#__PURE__*/_react.default.createElement("span", {
      className: "btn btn-primary",
      onClick: this.onSubmitTranslation
    }, "Save") : /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "btn btn-primary",
      disabled: true
    }, "Save")), /*#__PURE__*/_react.default.createElement(_components.ModalDialog, {
      isOpen: this.state.modalDialogOpen,
      headerText: `You will delete ${this.props.selection.length} item${this.props.selection.length !== 1 ? `s` : ``}`,
      bodyText: "Are you sure? This action cannot be undone.",
      buttonSecOnClick: this.toggleModalDialog,
      buttonSecText: "Cancel",
      buttonPrimOnClick: this.handleDeleteSelected,
      buttonPrimText: "Delete"
    }));
  }
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TranslateElementsTable);
module.exports = exports.default;